import mitt from 'mitt'

// Create a new event bus instance
const emitter = mitt()

// Create extended bus with $once functionality
const bus = {
  // Forward the standard mitt methods
  on: emitter.on,
  off: emitter.off,
  emit: emitter.emit,
  all: emitter.all,

  // Add $once method for backward compatibility with Vue 2
  $once: (event, handler) => {
    // Create a wrapper function that will remove itself after first execution
    const wrappedHandler = (...args) => {
      bus.off(event, wrappedHandler)
      handler(...args)
    }

    // Register the wrapped handler
    bus.on(event, wrappedHandler)

    // Return the bus for chaining
    return bus
  },

  // Add $on, $off, $emit aliases for backward compatibility
  $on: (event, handler) => {
    bus.on(event, handler)
    return bus
  },

  $off: (event, handler) => {
    bus.off(event, handler)
    return bus
  },

  $emit: (event, ...args) => {
    bus.emit(event, ...args)
    return bus
  }
}

// Export setup function for Vue 3
export const setupEventBus = app => {
  app.config.globalProperties.$bus = bus
}

export default bus
